export enum TemplateQuestionsRoutes {
  BasePrefix = "template-questions",
  ById = ":id",
  Search = "search"
}
